export const FORM_CHANGE_PASSWORD = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
};
